import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseLetterSpacingOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-letter-spacing-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';
import {useGetKeyFromSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromSelectedTextSlideItem';

interface TextSlideLetterSpacingOptionProps {
  className?: string;
}

export function TextSlideLetterSpacingOption({className = ''}: TextSlideLetterSpacingOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const scaleX = useGetKeyFromSelectedTextSlideItem('scaleX');
  const letterSpacing = useGetKeyFromTextStylesOfSelectedTextSlideItem('letterSpacing');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (scaleX === undefined || letterSpacing === undefined) {
    throw new Error('unable to get properties of letter spacing from text slide');
  }

  const updateLetterSpacing = (letterSpacing: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        textStyles: {
          letterSpacing,
        },
      },
      {
        undoable,
      }
    );
  };

  return <ItemBaseLetterSpacingOption className={className} letterSpacing={letterSpacing} scaleX={scaleX} onChangeLetterSpacing={updateLetterSpacing} />;
}
